var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',[_c('v-card-title',[_c('h4',[_vm._v("Level Adviser Overview")])]),_vm._v(" "),_c('v-card-text',[_c('h4',[_vm._v(_vm._s(_vm.department))]),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.level)+", "+_vm._s(_vm.programme))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }